export default __webpack_public_path__ + "static/media/team25.7fedd606.JPG";